import { useEffect, useState } from 'react';

import overlayEventContext from '../events/event';
import { OverlayData } from '../types';

interface Props {
  data: OverlayData;
}

const OverlayRenderer = ({ data }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClose = () => {
    setIsOpen(false);
    setTimeout(() => {
      overlayEventContext.notifyClose(data.id);
    }, 500);
  };

  useEffect(() => {
    requestAnimationFrame(() => {
      setIsOpen(true);
    });
  }, []);

  const Renderer = data.callback;
  return <Renderer isOpen={isOpen} onClose={onClose} />;
};

export default OverlayRenderer;
